import React, { useEffect, useState } from "react";
import styles from "../styles/ResetPasswordForm.css";
import { useLocation, useNavigate } from "react-router-dom";

const ResetPasswordForm = () => {
  const location = useLocation();
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (location.state?.email) {
      setEmail(location.state.email);
    }
  }, [location]);
  const navigate = useNavigate();

  const handleSendResetLink = (e) => {
    e.preventDefault(); // Prevent default form submission
    // Add logic here to handle sending the reset link (e.g., API call)
    console.log("Sending reset link to:", email);
    alert("Password reset link sent (check console)!"); // Placeholder feedback
  };

  const handleBackToLogin = () => {
    // Add logic here to navigate back to the login page
    console.log("Navigating back to login");
    navigate("/login");
  };

  const handleRegister = (e) => {
    e.preventDefault();
    // Add logic here to navigate to the registration page
    console.log("Navigating to registration");
    // alert("Navigating to registration (check console)!");
  };

  const handleContactSupport = (e) => {
    e.preventDefault();
    // Add logic here to navigate to the support page/contact form
    console.log("Navigating to contact support");
    alert("Navigating to contact support (check console)!"); // Placeholder feedback
  };

  return (
    // Use standard CSS class names
    <div className="reset-main-container">
      <div className="reset-password-container">
        <h1 className="reset-password-title">Reset Your Password</h1>
        <p className="reset-password-subtitle">
          Enter your email to receive a password reset link
        </p>

        <form onSubmit={handleSendResetLink} className="reset-password-form">
          <label htmlFor="email" className="reset-password-label">
            Email address
          </label>
          <div className="reset-password-input-wrapper">
            <span className="reset-password-input-icon">@</span>
            <input
              type="email"
              id="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your registered email"
              required
              className="reset-password-input"
            />
          </div>
          <p className="reset-password-helper-text">
            We'll send a password reset link to this email
          </p>

          <button type="submit" className="reset-password-send-button">
            Send Reset Link
          </button>
        </form>

        <div className="reset-password-or-separator">
          <span className="reset-password-or-text">Or</span>
        </div>

        <button
          onClick={handleBackToLogin}
          className="reset-password-back-button"
        >
          <span className="reset-password-back-icon">←</span> Back to Login
        </button>

        <p className="reset-password-register-link">
          Need an account?{" "}
          <a href="#" onClick={handleRegister}>
            Register here
          </a>
        </p>

        <hr className="reset-password-divider" />

        {/* <div className="reset-password-troubleshooting">
        <h2 className="reset-password-trouble-title">Having trouble?</h2>
        <p className="reset-password-trouble-text">
          If you don't receive the email within a few minutes, check your spam
          folder or <a href="#" onClick={handleContactSupport} className="reset-password-support-link">contact our support team</a>.
        </p>
      </div> */}
      </div>
    </div>
  );
};

export default ResetPasswordForm;
